import { PLANSTATUS, STATUS_PLAY_VIDEO } from './constants'

/** 天幕设备操作 - 播放器控制 msgType */
export const TIANMU_PLAYER_MSG_TYPE = '0x14370000'

/** provide/inject key：TianMuVideo 拉取列表后回传下载状态 */
export const SYNC_TIANMU_VIDEO_DOWNLOAD_STATUS = 'syncTianMuVideoDownloadStatus'

export function isTianMuPlayerMsgType(msgType) {
  return msgType === TIANMU_PLAYER_MSG_TYPE || msgType === 0x14370000
}

/** 是否为已下发成功的视频场景（与 TianMuVideo 过滤条件一致） */
export function isDownloadedTianMuVideoScene(item) {
  return item.SceneId !== 0 && item.SceneStatus === PLANSTATUS.AllSuccess
}

export function hasDownloadedTianMuVideoInList(list = []) {
  return list.some(isDownloadedTianMuVideoScene)
}

/** action 是否为「继续播放」 */
export function isTianMuContinuePlayAction(action) {
  if (!isTianMuPlayerMsgType(action?.MsgType)) {
    return false
  }
  const playerValue = action.Values?.find(
    v => v.ValueType === 'UIControl_TianMu_Player' && v.IsShow
  )
  return Number(playerValue?.DefaultValue) === STATUS_PLAY_VIDEO.Playing
}

export function buildTianMuVideoLibraryQuery({ PlanId, VDeviceId, ClassSku }) {
  return {
    Name: null,
    Types: null,
    PlanId,
    ResourceType: 'VIDEO',
    PageIndex: 1,
    PageSize: 500,
    VDeviceId,
    ClassSkus: [ClassSku],
    RoomCode: null,
    AppType: 128,
    ProductType: 'skyCanvas',
    IsIncloudeCustom: true,
    OnlyCreated: false,
  }
}
